import React from "react";
import styled from "styled-components";

const Loading = () => {
	return (
		<StyledDiv>
			<span className="ekene">
				Ekene<span className="dot">.</span>
			</span>
		</StyledDiv>
	);
};
export default Loading;

const StyledDiv = styled.div`
	display: grid;
	place-content: center;
	height: 100vh;
	background-color: white;

	.ekene {
		font-size: 3rem;
		font-weight: 700;
		letter-spacing: 4px;
		animation: mainFadeIn 2s forwards;
	}

	.dot {
		color: rgba(157, 0, 212, 1);
	}

	@keyframes mainFadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;
